"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const platform_1 = require("../common/platform");
const screen_1 = require("../common/screen");
const font_1 = require("./font");
const WEB_SIZE = 15;
const BACK_OFFICE_SIZE = 14;
const getBaseTextSize = () => {
    switch (true) {
        case (0, platform_1.isBackOffice)():
            return BACK_OFFICE_SIZE;
        case (0, platform_1.isWeb)():
            return WEB_SIZE;
        default:
            return (0, screen_1.getBaseSizeFromScreenWidth)();
    }
};
const getTexts = () => {
    const TEXT_BASE = getBaseTextSize();
    const RATIO = 1.2;
    // Returns text size based on a defined scale
    // See https://8thlight.com/blog/billy-whited/2011/10/28/r-a-ela-tional-design.html#tips
    // for reference.
    //
    // Note that this scale is pretty close to iOS design
    // guidelindes values for font sizes:
    // https://developer.apple.com/ios/human-interface-guidelines/visual-design/typography/
    //
    // Usage:
    //
    // ```
    // import ts from '../common/typeScale';
    //
    // const style = {
    //   fontSize = ts(0) // 16 pts
    // }
    // ```
    //
    // Example values:
    //
    // ts(-4) === 11
    // ts(-3) === 12
    // ts(-2) === 13
    // ts(-1) === 15
    // ts(0) === 16
    // ts(1) === 18
    // ts(2) === 19
    // ts(3) === 21
    // ts(4) === 23
    // ts(5) === 26
    // ts(6) === 28
    // ts(7) === 31
    // ts(8) === 34
    // ts(9) === 38
    // ts(10) === 42
    // ts(11) === 46
    // ts(12) === 50
    // ts(13) === 55
    //
    // [To go further: make it vary based on screen size]
    //
    const typeScale = (index) => Math.round(TEXT_BASE * RATIO ** index);
    return {
        fontFamily: (0, font_1.getFontFamily)(),
        typeScale,
    };
};
exports.default = getTexts;
